export default "__VITE_ASSET__Bv1U99H9__"